import { toursActive } from '../components/Driver/AwDriverContext'

export default {
  mounted(el, binding) {
    if (binding.value.active) {
      toursActive.delete(binding.value.name)
      toursActive.set(binding.value.name, binding.value.settings ? binding.value.settings : null)
    }
  },
  updated(el, binding) {
    if (binding.value.active) {
      toursActive.delete(binding.value.name)
      toursActive.set(binding.value.name, binding.value.settings ? binding.value.settings : null)
    } else if (!binding.value.active) {
      toursActive.delete(binding.value.name)
    }
  },
  unmounted(el, binding) {
    toursActive.delete(binding.value.name)
  }
}
